import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { LanguageListModel } from '../../models/customer/language-list.model';
import { Language } from '../../../../enums/language.enum';
import { CustomerBranchListModel } from '../../models/customer/customer-branch-list.model';
import { BranchListModel } from '../../models/customer/branch-list.model';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  customerList(page: number, size: number, filters: any = {}): Observable<any> {
    let url = `${
      environment.apiLocations.customer
    }/Customer?PageRequest.PageIndex=${page - 1}&PageRequest.PageSize=${size}`;

    if (filters.name) {
      url += `&Name=${filters.name}`;
    }

    if (filters.customerCode) {
      url += `&CustomerCode=${filters.customerCode}`;
    }

    if (filters.location) {
      url += `&Location=${filters.location}`;
    }

    if (filters.startCreatedDate) {
      url += `&StartCreatedDateTime=${filters.startCreatedDate}`;
    }

    if (filters.endCreatedDate) {
      url += `&EndCreatedDateTime=${filters.endCreatedDate}`;
    }

    if (filters.email) {
      url += `&Email=${filters.email}`;
    }

    if (filters.totalAnalysis) {
      url += `&TotalAnalysis=${filters.totalAnalysis}`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  allCustomerCodes(): Observable<any> {
    let url = `${environment.apiLocations.customer}/Customer/GetAllCustomerCodes`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getCustomer(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiLocations.customer}/Customer/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  createCustomer(organizationData: any): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiLocations.customer}/Customer`,
      organizationData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  editCustomer(id: string, organizationData: any): Observable<any[]> {
    return this.http.put<any[]>(
      `${environment.apiLocations.customer}/Customer/${id}`,
      organizationData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  deleteCustomer(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiLocations.customer}/Customer/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  allApplications(): Observable<any> {
    let url = `${environment.apiLocations.customer}/Customer/GetAllApplications`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  allLanguages(): LanguageListModel[] {
    return Object.keys(Language).map((key) => {
      return {
        code: Language[key as keyof typeof Language],
        name: key
      };
    });
  }

  applyLanguageSelection(): Array<{ name: string; value: boolean }> {
    return [
        { name: "Apply HeadOffice Language", value: true },
        { name: "Apply Branch Language", value: false }
    ];
  }

  getCustomerBranches(id: string): Observable<CustomerBranchListModel[]> {
    return this.http.get<CustomerBranchListModel[]>(
      `${environment.apiLocations.customer}/Customer/GetBranchesByCustomerId/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  deleteCustomerBranch(id:string): Observable<boolean> {
    return this.http.delete<boolean>(
      `${environment.apiLocations.customer}/Customer/branches/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  editCustomerBranch(id: string, branchData: any): Observable<any[]> {
   console.log("will edit customer branch");
    return this.http.put<any[]>(
      `${environment.apiLocations.customer}/Customer/branches/${id}`,
      branchData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
  customerBranchList(page: number, size: number, filters: any = {}): Observable<any> {
    let url = `${
      environment.apiLocations.customer
    }/Customer/branches/?PageRequest.PageIndex=${page - 1}&PageRequest.PageSize=${size}`;

    if (filters.name) {
      url += `&Name=${filters.name}`;
    }

    if (filters.customerCode) {
      url += `&CustomerCode=${filters.customerCode}`;
    }

    if (filters.startCreatedDate) {
      url += `&StartCreatedDateTime=${filters.startCreatedDate}`;
    }

    if (filters.endCreatedDate) {
      url += `&EndCreatedDateTime=${filters.endCreatedDate}`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  createBranch(branchData: any): Observable<any[]> {
    console.log("will create customer branch");
    return this.http.post<any[]>(
      `${environment.apiLocations.customer}/Customer/branches`,
      branchData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getCustomerBranch(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiLocations.customer}/Customer/branches/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getCustomerBranchesByCustomerCode(customerCode: string): Observable<BranchListModel[]> {
    return this.http.get<BranchListModel[]>(
      `${environment.apiLocations.customer}/Customer/GetBranchesByCustomerCode/${customerCode}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}
